module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"finished_subscription_purchase","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"value":{"type":"number","description":"in cents."}},"required":["user","value"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/finished_subscription_purchase.json
// module id = 535
// module chunks = 97